import { render, staticRenderFns } from "./IconEvents.vue?vue&type=template&id=2426bfa4&functional=true&"
import script from "./IconEvents.vue?vue&type=script&lang=js&"
export * from "./IconEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports